function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "LessonMenu-icon-back",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.999938,59.6874864 C53.9139673,59.6874864 65.187378,48.4140758 65.187378,34.5000465 C65.187378,20.5860172 53.9139673,9.31260654 39.999938,9.31260654 C26.0859087,9.31260654 14.8124981,20.5860172 14.8124981,34.5000465 C14.8124981,48.4140758 26.0859087,59.6874864 39.999938,59.6874864 Z M39.999938,54.8124981 C28.7773085,54.8124981 19.6874864,45.722676 19.6874864,34.5000465 C19.6874864,23.277417 28.7773085,14.1875949 39.999938,14.1875949 C51.2225675,14.1875949 60.3123896,23.277417 60.3123896,34.5000465 C60.3123896,45.722676 51.2225675,54.8124981 39.999938,54.8124981 Z M39.999938,44.55471 L39.999938,37.7500387 L51.7811599,37.7500387 C52.4514312,37.7500387 52.999907,37.2015629 52.999907,36.5312916 L52.999907,32.4688013 C52.999907,31.7985301 52.4514312,31.2500542 51.7811599,31.2500542 L39.999938,31.2500542 L39.999938,24.445383 C39.999938,23.358647 38.6897452,22.8102703 37.9179117,23.5821038 L27.8632482,33.6367673 C27.3858857,34.1141297 27.3858857,34.8859632 27.8632482,35.3633257 L37.9179117,45.4179892 C38.6897452,46.1797061 39.999938,45.641446 39.999938,44.55471 Z",
  id: "a",
  fill: "#FFF700",
  fillRule: "nonzero"
}));
function SvgLessonMenuIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "69px",
    viewBox: "0 0 80 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LessonMenu-icon-back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonMenuIconBack);
export default __webpack_public_path__ + "static/media/LessonMenu-icon-back.80a6e07ffe08516f284b76e189865575.svg";
export { ForwardRef as ReactComponent };